import PropTypes from 'prop-types'

import {useFormContext, Controller} from 'react-hook-form'
import {Stack} from '@mui/material'

import TextInput from './TextInput'

import './name.scss'

const Name = ({firstNameProp, label, lastNameProp}) => {
  const {control, formState: {errors}} = useFormContext()

  return (
    <div className='name'>
      <label
        aria-label='First and Last Name'
        className='label'
        htmlFor='first-name'>
        {label}
      </label>
      <Stack
        alignItems='flex-start'
        className='fields-container'
        direction={{mobileSm: 'column', tabletMd: 'row'}}
        spacing={1}>
        <Controller
          name={firstNameProp}
          control={control}
          defaultValue=''
          rules={{required: 'Please add the first name.'}}
          render={({field}) => (
            <TextInput
              {...field}
              ariaLabel={`${label} First Name`}
              id='first-name'
              placeholder='First'
              error={!!errors[firstNameProp]}
              helperText={errors[firstNameProp]?.message}
            />
          )}
        />
        <Controller
          name={lastNameProp}
          defaultValue=''
          control={control}
          rules={{required: 'Please add the last name.'}}
          render={({field}) => (
            <TextInput
              {...field}
              ariaLabel={`${label} Last Name`}
              id='last-name'
              placeholder='Last'
              error={!!errors[lastNameProp]}
              helperText={errors[lastNameProp]?.message}
            />
          )}
        />
      </Stack>
    </div>
  )
}

Name.defaultProps = {
  firstNameProp: 'first-name',
  label: 'Name',
  lastNameProp: 'last-name'
}

Name.propTypes = {
  firstNameProp: PropTypes.string,
  label: PropTypes.string,
  lastNameProp: PropTypes.string
}

export default Name
